interface AdditionalField {
    name: string;
    label: string;
    required: boolean;
    type: 'text' | 'number';
    validation?: RegExp;
    errorMessage?: string;
}

interface CountryRequirement {
    country: string;
    countryCode: string;
    additionalFields: AdditionalField[];
    info?: string;
}

export const countryRequirements: CountryRequirement[] = [
    {
        country: "Brazil",
        countryCode: "BR",
        additionalFields: [
            {
                name: "cpf",
                label: "CPF (Tax ID)",
                required: true,
                type: "text",
                validation: /^\d{3}\.\d{3}\.\d{3}-\d{2}$/,
                errorMessage: "Please enter a valid CPF in format: XXX.XXX.XXX-XX"
            }
        ],
        info: "CPF is required for customs clearance in Brazil"
    },
    {
        country: "India",
        countryCode: "IN",
        additionalFields: [
            {
                name: "gstin",
                label: "GSTIN (Tax ID)",
                required: true,
                type: "text",
                validation: /^\d{2}[A-Z]{5}\d{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
                errorMessage: "Please enter a valid GSTIN"
            }
        ],
        info: "GSTIN is required for customs clearance in India"
    },
    {
        country: "South Korea",
        countryCode: "KR",
        additionalFields: [
            {
                name: "customsID",
                label: "Customs ID",
                required: true,
                type: "text"
            }
        ],
        info: "Customs ID is required for shipments to South Korea"
    },
    {
        country: "Indonesia",
        countryCode: "ID",
        additionalFields: [
            {
                name: "npwp",
                label: "NPWP (Tax ID)",
                required: true,
                type: "text",
                validation: /^\d{2}\.\d{3}\.\d{3}\.\d{1}-\d{3}\.\d{3}$/,
                errorMessage: "Please enter a valid NPWP in format: XX.XXX.XXX.X-XXX.XXX"
            }
        ],
        info: "NPWP is required for customs clearance in Indonesia"
    },
    {
        country: "Thailand",
        countryCode: "TH",
        additionalFields: [
            {
                name: "taxID",
                label: "Tax ID",
                required: true,
                type: "text"
            }
        ],
        info: "Tax ID is required for customs clearance in Thailand"
    },
    {
        country: "Turkey",
        countryCode: "TR",
        additionalFields: [
            {
                name: "tckn",
                label: "TCKN (Turkish ID)",
                required: true,
                type: "text",
                validation: /^\d{11}$/,
                errorMessage: "Please enter a valid 11-digit TCKN"
            }
        ],
        info: "TCKN is required for customs clearance in Turkey"
    },
    {
        country: "Norway",
        countryCode: "NO",
        additionalFields: [
            {
                name: "vat",
                label: "VAT (Norwegian VAT ID)",
                required: true,
                type: "text",
                validation: /^\d{7}$/,
                errorMessage: "Please enter a valid 7-digit VAT ID"
            }
        ],
        info: "VAT ID is required for customs clearance in Norway"
    }
];

export const getCountryRequirements = (countryCode: string): CountryRequirement | undefined => {
    return countryRequirements.find(req => req.countryCode === countryCode.toUpperCase());
};

export const hasAdditionalRequirements = (countryCode: string): boolean => {
    return countryRequirements.some(req => req.countryCode === countryCode.toUpperCase());
};
